import { FC } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { ShapeWithTotalRecords } from '@app/constants';

import css from './BrowsePaginationTitle.module.scss';

type BrowsePaginationTitleProps = ShapeWithTotalRecords<{
  paginationTitle: MessageDescriptor;
  loadedRecordsAmount: number;
}>;

export const BrowsePaginationTitle: FC<BrowsePaginationTitleProps> = ({
  paginationTitle,
  loadedRecordsAmount,
  totalRecords,
}) => (
  <span className={css.paginationTitle} data-auto="pagination-title">
    <FormattedMessage
      {...paginationTitle}
      values={{
        loadedRecordsAmount,
        totalRecords,
      }}
    />
  </span>
);
